export default __webpack_public_path__ + "static/media/button.8dc2a852.png";